<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12" sm="6" md="4" xl="3">
        <StatusWidget />
      </v-col>

      <v-col>
        <v-row align="stretch">
          <v-col cols="12" sm="12" md="6" lg="4" xl="6">
            <DeviceInfoWidget />
          </v-col>
          <v-col
            v-for="[setting, parameter] in widgets"
            :key="'widget-gauge-' + setting.modbusAddressName"
            class="gauge-widget"
            cols="12"
            sm="12"
            md="6"
            lg="4"
            xl="3"
          >
            <GaugeWidget :settings="setting" :parameter="parameter" />
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-row justify="end">
      <v-col cols="12">
        <div>
          <h1 class="text-grey-darken-3 px-6 py-4 text-right">
            Under Construction
          </h1>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script setup lang="ts">
import { computed } from "vue";
import DeviceInfoWidget from "@/components/DeviceInfoWidget.vue";
import GaugeWidget from "@/components/GaugeWidget.vue";
import StatusWidget from "@/components/StatusWidget.vue";
import { useModbusAddress } from "@/composables/useModbusAddress";
import { ParamField } from "@/enums/ParamField";
import { PortState } from "@/enums/PortState";
import { dashboardItems } from "@/lib/dashboardItems";
import { useModbusStore } from "@/stores/useModbusStore";
import { DashboardItem } from "@/types/DashboardItem";
import { ModbusParam } from "@/types/ModbusParam";

const { modbusAddress } = useModbusAddress();
const modbusStore = useModbusStore();

function isTuple(
  maybeTuple: [DashboardItem, ModbusParam | undefined],
): maybeTuple is [DashboardItem, ModbusParam] {
  return maybeTuple[1] !== undefined;
}

const widgets = computed(() => {
  if (modbusStore.portState === PortState.connecting) {
    return [];
  }
  return dashboardItems
    .map((item): [DashboardItem, ModbusParam | undefined] => {
      const param = modbusStore.params.find(
        (param: ModbusParam) =>
          param[ParamField.mbusAddress] ===
          String(modbusAddress[item.modbusAddressName]),
      );
      return [item, param];
    })
    .filter(isTuple);
});
</script>

<style scoped lang="scss">
.dashboard-grid {
  display: grid;
  width: 100%;
  grid-auto-columns: minmax(min-content, max-content);
  grid-auto-rows: minmax(min-content, max-content);
  grid-gap: 1em;
  grid-auto-flow: column;
  .status-widget {
    grid-column: 1/6;
    grid-row: 1/3;
  }
  .info-widget {
    grid-column: 1/3;
  }
  .gauge-widget {
    grid-column: 1/2;
  }
}
</style>
